import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";

export default function Profile() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    role: "",
    account_type: "",
    status: "",
    provider_options: [],
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) {
      navigate("/");
      return;
    }

    try {
      const res = await fetch(`${API.PROFILE}&id=${user.id}`);
      const data = await res.json();

      console.log("🔍 API Response:", data); // Add this debug

      if (data.success) {
        let optionsArray = [];
        try {
          optionsArray = JSON.parse(data.user.provider_options || "[]");
          console.log("✅ Parsed options:", optionsArray); // Add this debug
        } catch {
          optionsArray = [];
        }

        setForm({
          name: data.user.name || "",
          email: data.user.email || "",
          phone: data.user.phone || "",
          city: data.user.city || "",
          state: data.user.state || "",
          role: data.user.role || "",
          account_type: data.user.account_type || "",
          status: data.user.status || "",
          provider_options: Array.isArray(optionsArray) ? optionsArray : [],
        });
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // ✅ FIXED: Use functional updates to avoid stale closures
  const handleProviderChange = (e) => {
    const value = e.target.value;
    setForm((prev) => {
      let updated = [...prev.provider_options];

      if (value === "visitor") {
        updated = updated.includes("visitor") ? [] : ["visitor"];
      } else {
        updated = updated.filter((item) => item !== "visitor");
        if (updated.includes(value)) {
          updated = updated.filter((item) => item !== value);
        } else {
          updated.push(value);
        }
      }

      const accountType =
        updated.includes("visitor") || updated.length === 0
          ? "customer"
          : "provider";

      return {
        ...prev,
        provider_options: updated,
        account_type: accountType,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const user = JSON.parse(sessionStorage.getItem("user"));

    try {
      const res = await fetch(API.UPDATE_PROFILE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: user.id, ...form }),
      });

      const data = await res.json();
      setLoading(false);

      if (data.success || data.status) {
        sessionStorage.setItem("user", JSON.stringify({ ...user, ...form }));
        window.dispatchEvent(new Event("userLogin"));

        const isVisitor = form.provider_options.includes("visitor");
        requestAnimationFrame(() => {
          alert("Profile Updated Successfully");
          if (isVisitor) {
            navigate("/");
          } else {
            navigate(-1);
          }
        });
      } else {
        alert(data.message || "Update failed");
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      alert("Failed to update");
    }
  };

  return (
    <div className="profile-popup-overlay" onClick={() => navigate(-1)}>
      <div
        className="profile-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="profile-main">
          <header className="profile-popup-header">
            <div className="profile-user-box">
              <div className="profile-avatar">
                {form.name?.charAt(0) || "U"}
              </div>
              <h5>{form.name || "User Name"}</h5>
            </div>
            <div className="profile-heading-area">
              <h4>Account Settings</h4>
              <p>Manage your public profile and service preferences</p>
            </div>
            <button className="profile-close-btn" onClick={() => navigate(-1)}>
              ✕
            </button>
          </header>

          <form onSubmit={handleSubmit} className="profile-popup-form">
            <div className="profile-grid">
              <div className="profile-field">
                <label>Full Name</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="profile-field">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="profile-field">
                <label>Mobile Number</label>
                <input name="phone" value={form.phone} readOnly />
              </div>
              <div className="profile-field">
                <label>City</label>
                <input name="city" value={form.city} onChange={handleChange} />
              </div>
              <div className="profile-field">
                <label>State</label>
                <input
                  name="state"
                  value={form.state}
                  onChange={handleChange}
                />
              </div>
              <div className="profile-field readonly">
                <label>Designation</label>
                <input name="role" value={form.role} readOnly />
              </div>
            </div>

            <div className="profile-provider-box">
              <h4>What do you provide?</h4>
              {/* 🔍 DEBUG DISPLAY */}

              <div className="profile-provider-grid">
                {[
                  { value: "visitor", label: "I am Visitor" },
                  { value: "machines", label: "I want to provide Machines" },
                  { value: "designers", label: "I am Designer" },
                  {
                    value: "workspaces",
                    label: "I want to give Workspace on Rent",
                  },
                ].map((opt) => (
                  <label key={opt.value} className="profile-checkbox-card">
                    <input
                      type="checkbox"
                      value={opt.value}
                      onChange={handleProviderChange}
                      checked={form.provider_options.includes(opt.value)}
                    />
                    <span className="reg-custom-check"></span>
                    {opt.label}
                  </label>
                ))}
              </div>
            </div>

            <footer className="profile-footer">
              <button
                type="submit"
                className="profile-save-btn"
                disabled={loading}
              >
                {loading ? <span className="loader"></span> : "Save Changes"}
              </button>
            </footer>
          </form>
        </div>
      </div>
    </div>
  );
}
